import { render, staticRenderFns } from "./SpotItemList.vue?vue&type=template&id=3f87c4a0"
import script from "./SpotItemList.vue?vue&type=script&lang=js"
export * from "./SpotItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports